module.exports = __webpack_public_path__ + "static/media/apartment9.c7738dd8.jpg";